// Mirrors practice/detailSections.ts's shape, trimmed to the sections this
// view-only tab needs - no field-key routing, since there's no form here.

export interface DetailSectionDef {
    id: string;
    label: string;
}

export const DETAIL_SECTIONS = [
    { id: 'info', label: 'Info' },
    { id: 'files', label: 'Files' },
    { id: 'beta', label: 'Feature settings' },
    { id: 'preferences', label: 'Preferences & protocols' }
] as const satisfies readonly DetailSectionDef[];

export type DetailSectionId = (typeof DETAIL_SECTIONS)[number]['id'];

export const DEFAULT_DETAIL_SECTION: DetailSectionId = 'info';

const DETAIL_SECTION_IDS = DETAIL_SECTIONS.map((section) => section.id);

export function isDetailSection(value: string): value is DetailSectionId {
    return (DETAIL_SECTION_IDS as readonly string[]).includes(value);
}
